__turbopack_context__.v({
  "control": "ForumHeader-module-scss-module__SVqg6G__control",
  "inline": "ForumHeader-module-scss-module__SVqg6G__inline",
  "root": "ForumHeader-module-scss-module__SVqg6G__root",
  "subtitle": "ForumHeader-module-scss-module__SVqg6G__subtitle",
  "titleColumn": "ForumHeader-module-scss-module__SVqg6G__titleColumn",
});
